// Global Components
import * as React from 'react';

// Types
type $OptionalProps = {
  className?: string;
  label?: string;
  required?: boolean;
};

type $Props = $OptionalProps & {
  name: string;
};

const InputLabelView = function ({
  className,
  label,
  name,
  required,
}: $Props) {
  return label ? (
    <label
      className={`text-gray-600 mb-1 text-xs sm:text-sm tracking-wide uppercase ${className || ''}`}
      htmlFor={name}
    >
      {label}
      {required && <span className={'ml-1 text-red-600'}>{'*'}</span>}
    </label>
  ) : null;
};

InputLabelView.defaultProps = {
  className: undefined,
  label: undefined,
  required: undefined,
};

export default InputLabelView;
